// extracted by mini-css-extract-plugin
export var childrenContainer = "_cw-0";
export var virtualScrollArea = "_cw-1";